import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  Input,
  Renderer2,
  type AfterViewChecked,
} from '@angular/core';

@Directive({ selector: '[myreMatchHeight]' })
export class MatchHeightDirective implements AfterViewChecked {
  private _elementRef = inject(ElementRef);
  private _renderer = inject(Renderer2);

  @Input()
  public myreMatchHeight: HTMLElement;

  public ngAfterViewChecked(): void {
    this.matchHeight();
  }

  @HostListener('window:resize.out-zone')
  public onResize(): void {
    this.matchHeight();
  }

  public matchHeight(): void {
    this._renderer.setStyle(
      this._elementRef.nativeElement,
      'height',
      `${this.myreMatchHeight.offsetHeight}px`,
    );
  }
}
